module.exports = __webpack_public_path__ + "static/img/bp1.b6a268e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/1911263/bp1.jpg
// module id = rh+d
// module chunks = 1